import SberBadge from './sber-badge/sber-badge'

import { STATIC_URL } from 'constants/data'

import styles from './banner-content.module.scss'

interface IIconData {
  src: string
  width: number
  height: number
  alt: string
}

interface ITag {
  name: string
  type: string
  nmoIconData?: IIconData
}

interface IBannerContent {
  tags: Array<ITag>
  badge?: JSX.Element
  title: string
  isNotAuthorized?: boolean
  description: JSX.Element
  lectorsWithAvatar: number[]
  mainColor: string
  dopLecturNames?: string
  dopLecturAmmount?: number
  linkId?: string
  scrollHandler?: () => void
  isNamesBreaked?: boolean
  lectorsMod?: string
}

const commonTagsData = (points: number) => [
  {
    name: 'Курс',
    type: 'text',
  },
  {
    name: 'Заочно',
    type: 'text',
  },
  {
    name: `${points} НМО`,
    type: 'nmo',
    nmoIconData: {
      src: `${STATIC_URL}/courses/nmo_icon.png`,
      width: 18,
      height: 18,
      alt: 'Книжка',
    },
  },
]

const cardioLectors = [27, 172, 366]
const neuroLectors = [4, 35, 334]
const osteoLectors = [11, 29, 34, 179]
const modernMethodsDmpLectors = [6, 546, 549]
const cardioGoldLectors = [11, 334, 27]
const gastroLectors = [176]
const geriatriaLectors = [11, 334, 27]
const geriatriaBasicLectors = [21, 118, 3]
const somnologyLectors = [13]

const cardioBannerData = {
  tags: commonTagsData(18),
  title: `Избранные вопросы</br> по кардиологии`,
  description: (
    <>
      Обучение на основе курса «Кардиология <span className={styles.bold}>“Золотой стандарт”</span>
      ».
      <br />
      Программа курса фокусируется на важных вопросах диагностического поиска, оценки рисков и
      назначения адекватного лечения согласно клиническим данным.
    </>
  ),
  lectorsWithAvatar: cardioLectors,
  dopLecturNames: ' Соловьева А.Е, Багликов А.Н, Новицкий Н.И, Громыко Г.А.',
  dopLecturAmmount: 4,
  mainColor: '#e1f3ff',
}

const somnologyBannerData = {
  tags: [...commonTagsData(18)],
  title: `Расстройства сна: современные<br/>подходы к диагностике и лечению`,
  description: (
    <>
      Расстройства сна — распространенная и актуальная проблеме в любом возрасте. Сон является
      важной биологической функцией, участвующий в регуляции многих систем организма.
    </>
  ),
  lectorsWithAvatar: somnologyLectors,

  mainColor: '#e1f3ff',
}

const neuroBannerData = {
  tags: commonTagsData(18),
  title: `Когнитивные расстройства</br> в гериатрической практике`,
  description: (
    <>
      Особое внимание в программе уделяется нейрокогнитивному тестированию и интерпретации его
      результатов, для разработки индивидуальной комплексной программы ухода для пожилых пациентов.
    </>
  ),
  lectorsWithAvatar: neuroLectors,
  mainColor: '#E1DBCB',
  isNamesBreaked: true,
}

const osteoBannerData = {
  tags: commonTagsData(18),
  title: `Остеопороз: современные подходы</br> к диагностике и лечению`,
  description: (
    <>
      В России с 2024 года все регионы приняли программы по профилактике падений и переломов у
      пожилых людей. Меры, разработанные в Российском геронтологическом научно-клиническом центре,
      были опробованы в 27 пилотных регионах в 2022-2023 году и показали свою эффективность.
    </>
  ),
  lectorsWithAvatar: osteoLectors,
  mainColor: '#E1F3FF',
  isNamesBreaked: true,
}

const modernMethodsDmpBannerData = {
  tags: commonTagsData(18),
  badge: <SberBadge />,
  title: `Современные</br>методики дистанционного</br> мониторинга пациентов`,
  description: (
    <>
      Обучение, основанное на <span className={styles.bold}>практическом опыте внедрения</span>{' '}
      передовых технологий дистанционного медицинского наблюдения за состоянием здоровья пациентов в
      государственном здравоохранении{' '}
      <span className={styles.bold}>на территории 69 субъектов РФ</span>
    </>
  ),
  lectorsWithAvatar: modernMethodsDmpLectors,
  dopLecturNames: ' Филатова В.А, Пермикина И.В, Евсикова М.М.',
  dopLecturAmmount: 3,
  mainColor: '#E1DBCB',
}

const cardioGoldBannerData = {
  tags: commonTagsData(36),
  title: `Кардиология </br> ”Золотой стандарт”`,
  description: (
    <>
      Обучение на основе курса от крупнейшего медицинского центра в мире - Mayo&nbsp;Clinic,
      адаптированного под&nbsp;российскую клиническую практику.
    </>
  ),
  lectorsWithAvatar: cardioGoldLectors,
  dopLecturNames: ' и еще 6 лекторов',
  dopLecturAmmount: 6,
  mainColor: '#E1DBCB',
  isNamesBreaked: true,
}

const gastroBannerData = {
  tags: commonTagsData(18),
  title: `Заболевания желудочно-кишечного тракта: современные подходы к&nbsp;диагностике и лечению `,
  description: (
    <>
      Сегодня чаще встречаются поражения верхнего отдела ЖКТ и нивелируются различия по половому
      признаку. Это требует пересмотра существующих подходов к диагностике и терапии в
      гастроэнтерологии.
    </>
  ),
  lectorsWithAvatar: gastroLectors,
  mainColor: '#E1DBCB',
}

const geriatriaBannerData = {
  tags: commonTagsData(144),
  title: `Современная гериатрия <br /> для практикующих врачей `,
  description: (
    <>
      С лекторами курса разбираемся с чрезвычайно важной задачей: выявление и профилактика
      потенциальных, обусловленных возрастом, гериатрических синдромов, слабости и дефицитов и
      необходимости организации мероприятий для обеспечения сохранности пожилого человека.
    </>
  ),
  lectorsWithAvatar: geriatriaLectors,
  dopLecturNames: ' и еще 21 лектор',
  dopLecturAmmount: 21,
  mainColor: '#E1DBCB',
  isNamesBreaked: true,
}

const geriatriaBasicBannerData = {
  tags: [...commonTagsData(18)],
  title: `Основы гериатрии: <br/>возраст-ассоциированные заболевания и тактика их ведения`,
  description: (
    <>
      Гериатрия сегодня — самое молодое и быстро развивающееся <br /> направление медицины.
    </>
  ),
  lectorsWithAvatar: geriatriaBasicLectors,
  dopLecturNames: ' Наумов А.В., Кривободородов Г.Г.',
  dopLecturAmmount: 2,
  isNamesBreaked: true,
  mainColor: '#E1F3FF',
}

export type { IBannerContent }
export {
  cardioBannerData,
  somnologyBannerData,
  neuroBannerData,
  modernMethodsDmpBannerData,
  osteoBannerData,
  cardioGoldBannerData,
  gastroBannerData,
  geriatriaBannerData,
  geriatriaBasicBannerData,
}
